import SettleBetStore from "./SettleBetStore";

class SettleBetStoreFactory {
    create() {
        return new SettleBetStore();
    }
}

export default new SettleBetStoreFactory();
